var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "w-100 pt-20 pt-md-30 pt-lg-34 border-top"
  }, [_c('v-img', {
    staticClass: "mb-12 mb-lg-30",
    attrs: {
      "src": _vm.icon,
      "max-width": _vm.iconWidth
    }
  }), _vm.tit ? _c('h5', {
    staticClass: "tit--sm font-weight-medium mb-6 mb-lg-14"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]) : _vm._e(), _vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }